import Toast from "./Toast";
import type { Toast as ToastData } from "../hooks/useToast";
import { s } from "../style.js";

export default function ToastContainer({ toasts, onDismiss }: { toasts: ToastData[]; onDismiss: (id: string) => void }) {
  return (
    <div style={s("position:absolute; right:24px; bottom:24px; z-index:50; display:flex; flex-direction:column; gap:8px; align-items:flex-end; pointer-events:none")}>
      {toasts.slice().reverse().map((toast) => (
        <div key={toast.id} style={s("pointer-events:auto")}><Toast {...toast} onDismiss={onDismiss} /></div>
      ))}
    </div>
  );
}
